"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.segmentMatcherContext = void 0;
var thenable_1 = require("../../utils/promise/thenable");
var constants_1 = require("../../logger/constants");
function segmentMatcherContext(log, segmentName, storage) {
    return function segmentMatcher(key) {
        var isInSegment = storage.segments.isInSegment(segmentName, key);
        if ((0, thenable_1.thenable)(isInSegment)) {
            isInSegment.then(function (result) {
                log.debug(constants_1.ENGINE_MATCHER_SEGMENT, [segmentName, key, isInSegment]);
                return result;
            });
        }
        else {
            log.debug(constants_1.ENGINE_MATCHER_SEGMENT, [segmentName, key, isInSegment]);
        }
        return isInSegment;
    };
}
exports.segmentMatcherContext = segmentMatcherContext;
